import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';

@Injectable({
  providedIn: 'root'
})
export class TutorService {

  constructor(
    private _http: HttpClient
  ) { }

  public getTutors(){
    return this._http.get(environment.apiEndpoint + '/api/admin/tutors').pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public getTutorsPaginated(page,pp,sorts,filters): Observable<iHttpPaginatedResponse> {
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/tutorsPaginated?page=${page}&pp=${pp}&sort=${sorts}&${filters}`).pipe(
      map((res:any) => {
        let tutors=[];
        res.data.forEach(tutor=>{
          tutors.push(tutor);
        });
        res.data = tutors;
        return res;
      })
    );
  }

  public getTutor(tutorId:number){
    return this._http.get(environment.apiEndpoint + '/api/admin/tutor/' + tutorId).pipe(
      map(
        (res:any) => {
          return res;
        }
      )
    );
  }

  public updateTutor(tutor:any, fileB64:string, fileType:string){
    return this._http.put(environment.apiEndpoint + '/api/admin/tutor/' + tutor.id, {tutor:tutor, fileB64:fileB64, fileType:fileType}).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public addTutor(){
    return this._http.post(environment.apiEndpoint + '/api/admin/tutor', {name: 'New tutor...'}).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }
}
